import * as React from 'react';
import { useEffect } from 'react';

// tools and component for date picker
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import 'dayjs/locale/fr';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

//Redux hooks and tools
import { useSelector, useDispatch } from "react-redux";
import { periodDatesSlice, periodHeuresSlice } from "../../../../../../store/periodSlice.js";
import { getRidingPeriod } from "../../../../../../store/selectors.js";
import { getIdSpot, getIdSpotLoc, getContrat } from "../../../../../../store/selectors.js";

//import created time select component (in same folder)
import ListHoraires from '../listHoraires/ListHoraires'
import DetailsHoraires from '../../../../../../steps/step1/components/detailsHoraires/DetailsHoraires'

//import utils functions to calculate horaires and times
import { getHoraires } from '../../../../../../utils/dateTimeFunctions.js'


//component for both start and return dates AND time -> inclues 2 datepicker components + 2 time select components
//prop : boolean to disable date pickers or not (when no spot is selected)
export default function PeriodPicker({ activate, managerMode }) {

  let idSpot = useSelector(getIdSpot);
  const idSpotLoc = useSelector(getIdSpotLoc);
  const currentContrat = useSelector(getContrat);
  idSpot = managerMode === true ? idSpotLoc : idSpot;

  const [horaires, setHoraires] = React.useState([{}, {}]);
  const [regul, setRegul] = React.useState(false);
  const dispatch = useDispatch();



  let ridingPeriod = useSelector(getRidingPeriod); //global state : array of 2 arrays (2 dates,2 times)
  let date1 = ridingPeriod[0][0];
  let date2 = ridingPeriod[0][1];
  let deltaJours = dayjs(currentContrat.date2).diff(dayjs(currentContrat.date1), 'day');
  console.log(deltaJours);

  const today = dayjs();
  //const tomorow = managerMode === true ? today : today.add(1, 'day');
  const tomorow = today;

  /* useEffect(() => { //change opening hours when spot change (idspot as dependency)



  }, [idSpot]) */

  async function initHoraires() { //we add this inner function to manage asynchrone

    if (idSpot > 0 || (managerMode === true && idSpotLoc > 0)) { //only when spot is already chosen (not at first render)
      let horaires1 = await getHoraires(dayjs(date1).format('YYYY-MM-DD'), idSpot);

      if (ridingPeriod[1][0] === 0) { //only if start hour not set yet
        if (managerMode === true) {
          let timeNow = horaires1.am_start;
          timeNow = parseInt(dayjs().hour());
          timeNow = timeNow < horaires1.am_start ? horaires1.am_start : timeNow;
          timeNow = timeNow >= horaires1.pm_end ? horaires1.pm_end - 1 : timeNow;
          timeNow = timeNow > horaires1.am_end && timeNow < horaires1.pm_start ? horaires1.pm_start : timeNow;

          dispatch(periodHeuresSlice.actions.setHeure({ heure: timeNow, index: 1 }));
          dispatch(periodDatesSlice.actions.setDate({ jour: dayjs().format('YYYY-MM-DD'), index: 1 })); //update global state (date)

        } else {
          dispatch(periodHeuresSlice.actions.setHeure({ heure: horaires1.am_start, index: 1 }));
        }
      }

      let horaires2 = await getHoraires(dayjs(date2).format('YYYY-MM-DD'), idSpot);
      if (ridingPeriod[1][1] === 0) { //only if start hour not set yet
        if (managerMode === true) {
          dispatch(periodHeuresSlice.actions.setHeure({ heure: horaires2.pm_end, index: 2 }));
          dispatch(periodDatesSlice.actions.setDate({ jour: dayjs().format('YYYY-MM-DD'), index: 2 })); //update global state (date)

        } else {
          dispatch(periodHeuresSlice.actions.setHeure({ heure: horaires2.pm_start, index: 2 }));
        }
      }

      setHoraires([horaires1, horaires2]); //useEffect Method to rerender 
    }
  } //end of async function

  initHoraires(); //call the inner asnchrone function



  // params : jour = date as dayjs object, index to set start or return date
  async function handleChangeDate(jour, index) { //when date is changed 
    let horaireDuJour = await getHoraires(jour.format('YYYY-MM-DD'), idSpot); //get horaires returns every infos about opening hours, this day, this spot

    let debs = [0, 0];
    let otherIndex = index === 1 ? 2 : 1;

    dispatch(periodDatesSlice.actions.setDate({ jour: jour.format('YYYY-MM-DD'), index: index })); //update global state (date)
    dispatch(periodDatesSlice.actions.setDate({ jour: jour.add(deltaJours, 'day').format('YYYY-MM-DD'), index: otherIndex })); //update global state (date)






    if (horaireDuJour.ferme === true) { //closed day,...
      //...we set hour at 0 in global staaate
      dispatch(periodHeuresSlice.actions.setHeure({ heure: 0, index: index }));
    }



  }

  // manage case when Date1 > Date2
  function regulDates(jour) {
    if (jour.isAfter(dayjs(date2))) {
      dispatch(periodDatesSlice.actions.setDate({ jour: jour.format('YYYY-MM-DD'), index: 2 }));
      setRegul(true);
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr"> {/* fr params for date format */}
      <div className='period-picker'>
        <div className='period-picker-start'>
          <div>
            <DatePicker
              disabled={false}
              label="Départ"
              value={dayjs(date1)}
              minDate={dayjs(tomorow)}
              maxDate={null}
              onChange={(newValue) => handleChangeDate(newValue, 1)}
              className='date-picker'
            />
            <ListHoraires horaires={horaires[0]} index={1} />
          </div>
          <DetailsHoraires horaires={horaires[0]} activate={activate} />
        </div>

        <div className='period-picker-return'>
          <div>
            <DatePicker
              disabled={true}
              label="Retour"
              value={dayjs(date2)}
              minDate={null}
              onChange={(newValue) => handleChangeDate(newValue, 2)}
              className='date-picker'
            />
            <ListHoraires horaires={horaires[1]} index={2} />
          </div>
          <DetailsHoraires horaires={horaires[1]} activate={activate} />

        </div>


      </div>
    </LocalizationProvider>
  );
}